export default __webpack_public_path__ + "static/media/05.88f7b50f.jpeg";